<template>
  <div class="max-width-600 padding-top padding-bottom">
    <div class="row">
      <div class="col text-center">
        <h2 class="mb-5">Look Up Invoice</h2>
      </div>
    </div>

    <div class="row">
      <div class="col text-center" style="align-self: center">
        <img
          style="max-width: none"
          class="img-responsive"
          src="\images\pay-invoice-icon.png"
          title="Invoice Lookup"
        />
      </div>
      <div class="col">
        <div class="pb-3">
          <label for="invoiceNumber">Invoice Number</label>
          <input type="text" id="invoiceNumber" v-model="invoice_number" />
        </div>

        <div class="pb-3">
          <label for="invoiceDueDate">Due Date</label>
          <input type="date" id="invoiceDueDate" v-model="invoice_due_date" />
        </div>

        <div class="pb-3">
          <label for="invoiceBalanceDue">Balance Due</label>
          <input
            type="text"
            id="invoiceBalanceDue"
            v-model="invoice_balance_due"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col text-center">
        <button
          type="button"
          class="button-green btn px-5"
          v-on:click="sendCode()"
        >
          <template v-if="is_loading">Submitting...</template>
          <template v-else>Submit</template>
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col pb-3 text-center">
        <p
          class="my-1"
          :class="has_error ? 'error-message' : 'success-message'"
        >
          {{ this.message }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InvoiceLookupComponent',
    props: {},
    data: function () {
      return {
        message: '',
        has_error: false,
        is_loading: false,
        invoice_number: '',
        invoice_due_date: '',
        invoice_balance_due: '',
      };
    },
    mounted() {},
    computed: {
      // invoice_balance_due_formatted: {
      //     get() {
      //         const value = this.invoice_balance_due.replaceAll(/\D/g, "");
      //         const dollars = parseInt(value) / 100; // Convert cents to dollars
      //         return `$${dollars.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`; // Add "$" symbol and format as a dollar amount with comma separator
      //     },
      //     set (value) {
      //         this.invoice_balance_due = value;
      //     }
      // },
      can_submit_page: function () {
        if (
          this.invoice_number &&
          this.invoice_due_date &&
          this.invoice_balance_due
        ) {
          return true;
        }

        return false;
      },
    },
    methods: {
      clearErrors: function () {
        this.message = '';
        this.has_error = false;
      },
      formatToFloat: function (formattedNumber) {
        // Remove any non-numeric characters
        const numericString = formattedNumber.replace(/[^0-9.-]+/g, '');

        // Parse the resulting string as a float
        const floatValue = parseFloat(numericString);

        // Return the float value
        return floatValue;
      },
      sendCode: function () {
        this.message = '';
        this.has_error = false;
        this.is_loading = true;

        axios
          .post('/dashboard/pay-invoice', {
            invoice_number: this.invoice_number,
            invoice_due_date: this.invoice_due_date,
            // format and parse to float
            // invoice_balance_due: this.formatToFloat(this.invoice_balance_due_formatted),
            invoice_balance_due: this.invoice_balance_due,
          })
          .then((success) => {
            this.has_error = !success.data.success;
            this.is_loading = false;

            if (success.data.success) {
              // go to checkout page
              window.location = '/checkout';
            } else {
              this.message = success.data.message;
            }
          })
          .catch((error) => {
            this.has_error = true;
            this.is_loading = false;
            this.message =
              'Error trying to capture invoice. Please contact support.';
          });
      },
    },
  };
</script>
